import React from "react";
import PropTypes from "prop-types";

import { Button, Responsive } from "semantic-ui-react";

function TriggerButton({ title, icon, isActive, onClick, ...props }) {
  return (
    <React.Fragment>
      <Responsive
        data-test="hub-menu-insight-button"
        style={{ marginRight: 0 }}
        as={Button}
        basic
        icon={icon}
        maxWidth={1350}
        onClick={onClick}
        primary={isActive}
        {...props}
      />
      <Responsive
        data-test="hub-menu-insight-button"
        style={{ marginRight: 0, whiteSpace: "nowrap" }}
        as={Button}
        basic
        content={title}
        icon={icon}
        minWidth={1351}
        onClick={onClick}
        primary={isActive}
        {...props}
      />
    </React.Fragment>
  );
}

TriggerButton.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

TriggerButton.defaultProps = {
  title: "Insights",
  icon: "pie graph",
  isActive: false,
};

export default TriggerButton;
